import styled from "@emotion/styled";
import { Box, Stack, Typography } from "@mui/material";
import { colors } from "@zfp-akademie-a-s/zfp-design";
import { Radius, Spacing } from "Infrastructure/Themes/Themes";
import type { PropsWithChildren } from "react";

type Props = {
  readonly name: string;
  readonly description: string;
  readonly renderSwitch: () => React.ReactNode;
};

const StyledWrapper = styled(Box)`
  ${({ theme }) => `
    box-sizing: border-box;
    border: ${`1px solid ${colors.borderLight}`};
    border-radius: ${theme.spacing(Radius.L)};
    padding: ${theme.spacing(Spacing.XL)};
    background: ${colors.white};
  `}
`;

export const ChildLifePhase: React.FC<PropsWithChildren<Props>> = ({ name, description, children, renderSwitch }) => {
  return (
    <StyledWrapper>
      <Stack spacing={children ? Spacing.XL : 0}>
        <Box display="flex">
          <Box>{renderSwitch()}</Box>
          <Box>
            <Typography display="block" fontWeight={500} variant="body2">
              {name}
            </Typography>
            <Typography variant="body2" color="secondary">
              {description}
            </Typography>
          </Box>
        </Box>
        <Box>{children}</Box>
      </Stack>
    </StyledWrapper>
  );
};
